export default {
  "regularLanguages": [
    {
      "title": "Português (Brasil)",
      "link": "/br",
      "hreflang": "pt"
    },
    {
      "title": "English",
      "link": "/",
      "hreflang": "en"
    },
    {
      "title": "Español",
      "link": "/es",
      "hreflang": "es"
    }
  ],
  "circleLanguages": [
    {
      "title": "BR",
      "link": "/br",
      "hreflang": "pt"
    },
    {
      "title": "EN",
      "link": "/",
      "hreflang": "en"
    },
    {
      "title": "ES",
      "link": "/es",
      "hreflang": "es"
    }
  ]
}
